import { render, staticRenderFns } from "./permisosUsuarios.vue?vue&type=template&id=36946553&scoped=true&"
import script from "./permisosUsuarios.vue?vue&type=script&lang=js&"
export * from "./permisosUsuarios.vue?vue&type=script&lang=js&"
import style1 from "./permisosUsuarios.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36946553",
  null
  
)

export default component.exports